import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAccountB2CRetrievalVerifyOTPUseCase {
    execute(apiKey: string, otp: string, username: string, userId?: string, productKey?: string): Promise<any>;
}

export class AccountB2CRetrievalVerifyOTPUseCase implements IAccountB2CRetrievalVerifyOTPUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string, otp: string, username: string, userId?: string, productKey?: string): Promise<any> {
        const result = await this.profileRepository.accountB2CRetrievalVerifyOTP(
            apiKey,
            otp,
            username,
            userId,
            productKey
        );
        return result.data;
    }
}
